import { EFormNavigationDirections, stepControlsContextObj, useFormContext } from '@cian/frontend-request-form-widget';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { EStepCodes } from '../../types/requestForm';
import { selectModerationIssues } from '../../selectors/moderationIssues';
export function useAutoSubmitSteps() {
  var _React$useContext = React.useContext(stepControlsContextObj),
    currentStep = _React$useContext.currentStep,
    lastNavDirection = _React$useContext.lastNavDirection,
    setPrevStep = _React$useContext.setPrevStep;
  var _useFormContext = useFormContext(),
    handleSubmit = _useFormContext.handleSubmit,
    values = _useFormContext.values;
  var moderationIssues = useSelector(selectModerationIssues);
  var topic = values.topic;
  var skipStep = function skipStep() {
    if (lastNavDirection === EFormNavigationDirections.Backward) {
      setPrevStep();
    } else {
      handleSubmit();
    }
  };

  /**
   * Здесь добавляем шаги, которые нужно пропустить при определённых условиях.
   *
   * Пример:
   * Если бекенд прислал нам данные, то показываем экран А, если они оказались пустыми - экран В.
   * Чтобы отобразить экран В мы делаем автоматически handleSubmit(), который пропускает экран A
   * и переходит сразу к экрану B, то есть пропускает один шаг.
   */
  React.useEffect(function () {
    // Пропускаем шаг с выбором темы, если тема уже была передана заранее (подробности в AUD-2473)
    if (currentStep.code === EStepCodes.Topic && topic) {
      skipStep();
      return;
    }
    if (currentStep.code === EStepCodes.ModerationIssues && moderationIssues.issues.length === 0) {
      skipStep();
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep]);
}